<mat-spinner [diameter]="86" *ngIf="loading"></mat-spinner>
<div class="content" *ngIf="!loading">
  <div class="back" routerLink="/user/profile/seats">
    <img
      src="../../../../assets/images/Icon-back.svg"
      alt=""
      [width]="16"
      [height]="16"
    />返回车票页
  </div>
  <div class="img">
    <div class="fleet-top">
      <div class="fleet-left">
        <app-image
          [fileid]="seat?.valid_period.icon"
          width="58px"
          height="58px"
        ></app-image>
      </div>
      <div class="fleet-middle">
        <div class="fleet-title">{{ seat?.valid_period.platform }}</div>
        <!-- <div class="fleet-subtitle">标准车队套餐月付</div> -->
      </div>
    </div>
    <div class="fleet-down">
      <div class="fleet-right">
        <div class="expiration">
          <img
            src="../../../../assets/images/Icon-time.svg"
            [width]="16"
            [height]="16"
            alt=""
          />
          到期时间：<span
            ><app-date [text]="seat?.valid_period.ended_time"></app-date
          ></span>
        </div>
        <div class="remainder">
          <img
            src="../../../../assets/images/Icon-funnel.svg"
            [width]="16"
            [height]="16"
            alt=""
          />
          剩余时长：<span>{{ seat?.valid_period.remaining_days }}天</span>
        </div>
        <div class="remainder">
          <img
            src="../../../../assets/images/Icon-times.svg"
            [width]="16"
            [height]="16"
            alt=""
          />
          总次数：<span>{{ modelsOriginally?.times }}</span>
        </div>
        <div class="remainder">
          <img
            src="../../../../assets/images/Icon-duration.svg"
            [width]="16"
            [height]="16"
            alt=""
          />
          恢复时间：<span>{{ modelsOriginally?.duration }}小时</span>
        </div>
      </div>
      <div class="item">
        <nz-progress
          [nzPercent]="
            calculatePercent(models?.remain, modelsOriginally?.times)
          "
          nzType="circle"
          [nzWidth]="52"
          nzStrokeColor="#01C6B4"
          [nzFormat]="format(models)"
        ></nz-progress>
        <div class="situation">剩余次数</div>
      </div>
    </div>
  </div>

  <div class="title">
    <div class="left">
      <!-- <div class="name">车队信息</div>
      <div class="node" (click)="checkNode()">
        <img
          src="../../../../assets/images/Icon-node.svg"
          alt=""
          [width]="14"
          [height]="14"
        />节点二
      </div> -->
    </div>
    <div class="right">
      <img
        src="../../../../assets/images/Icon-tip.svg"
        [width]="20"
        [height]="20"
        alt=""
        style="margin-right: 10px"
      />
      <div class="board" routerLink="/user/profile/history/board">
        <img
          src="../../../../assets/images/Icon-board.svg"
          [width]="14"
          [height]="14"
          alt=""
        />历史公告
      </div>
      <div class="explain" (click)="explain()" [matMenuTriggerFor]="menu">
        <img
          src="../../../../assets/images/Icon-explain.svg"
          [width]="14"
          [height]="14"
          alt=""
        />使用说明
      </div>

      <div class="visit" (click)="visit()" style="cursor: default">
        <img
          src="../../../../assets/images/Icon-eye.svg"
          [width]="14"
          [height]="14"
          alt=""
        />近期访问
      </div>
    </div>
  </div>

  <div class="fleet">
    <app-fleet-card-loader [loader]="findFleetCards" style="overflow: hidden">
      <ng-container *ngFor="let item of cards">
        <app-fleet-card [data]="item" [tokens]="tokens"></app-fleet-card>
      </ng-container>
    </app-fleet-card-loader>
  </div>
</div>

<mat-menu #menu="matMenu" class="explainMenu">
  <div class="menu-title">使用说明</div>
  <div class="menu-detail">
    <div class="menu-item">
      <span class="spot"></span>
      <span class="text">
        <span>保存对话:</span>保存的是停留在页面中的整个对话，其余对话需先
        点击进入再进行保存。
      </span>
    </div>
    <div class="menu-item">
      <span class="spot"></span>
      <span class="text">
        <span>限制:</span>由于配置了原生GPT账号，达到次数上限后需要手动点
        击更换，或选择其他车队。
      </span>
    </div>
    <div class="menu-item">
      <span class="spot"></span>
      <span class="text">
        <span>避免:</span>尽量避免提问“你好，你是谁，你能做什么”等浪费使用
        次数的问题。提问时只需完整表达自己的想法，发送即可。
      </span>
    </div>
  </div>
</mat-menu>
